const cardData = [
  {
    icon: "/assets/SoftwareInt/img1.svg",
    heading: "API Integration",
    paragraph:
      "Timely precision, where promises meet performance, ensuring your project's success.",
  },
  {
    icon: "/assets/SoftwareInt/img2.svg",
    heading: "Data Synchronization",
    paragraph:
      "Timely precision, where promises meet performance, ensuring your project's success.",
  },
  {
    icon: "/assets/SoftwareInt/img3.svg",
    heading: "Authentication",
    paragraph:
      "Timely precision, where promises meet performance, ensuring your project's success.",
  },
];

const points = [
  { content1: "Scale your infrastructure as your business grows" },
  { content1: "Reduce IT overhead and hardware costs" },
  { content1: "Access services from anywhere, anytime" },
  { content1: "Ensure data security and disaster recovery" },
  { content1: "Automate updates and maintenance" },
];

export { cardData, points };
